import React, { useState } from 'react';
import ContentLoader from 'react-content-loader';
import { COLORS } from '../../constants';
import { ImgWrapper } from '../Styled';
import defaultImage from '../../assets/default.jpg';

interface IStyledImageWrapper {
  src?: string;
  width: string;
  height: string;
  alt: string;
}

export const Image: React.FC<IStyledImageWrapper> = (props): JSX.Element => {
  const { src, alt, width, height } = props;
  const [isDefault] = useState(!src);
  const [isLoaded, setLoad] = useState(false);

  const img = isDefault ? defaultImage : src;

  return (
    <ImgWrapper width={width} height={height}>
      {isLoaded ? null : (
        <ContentLoader
          height={88}
          width={188}
          speed={1}
          backgroundColor={COLORS.gainsboro}
          foregroundColor={COLORS.white}
          viewBox="0 0 188 88"
        >
          <rect x="0" y="0" rx="5" ry="5" width="188" height="88" />
        </ContentLoader>
      )}
      <img
        style={isLoaded ? { width: '100%' } : { display: 'none' }}
        src={`${img}`}
        alt={alt}
        onLoad={() => setLoad(true)}
      />
    </ImgWrapper>
  );
};

export const SimpleImage: React.FC<IStyledImageWrapper> = (props): JSX.Element => {
  const { src, alt, width, height } = props;
  const [isDefault] = useState(!src);

  const img = isDefault ? defaultImage : src;

  return (
    <ImgWrapper width={width} height={height}>
      <img data-testid="simple-image" style={{ width: '100%' }} src={`${img}`} alt={alt} />
    </ImgWrapper>
  );
};
